<template>
  <v-layout row justify-center>
    <v-dialog v-model="showLogoForm" max-width="600px">
      <v-form>
        <v-card class="modern-modal">
          <div class="modal-head">
            <div class="modal-head-icon"><v-icon color="white">photo_camera</v-icon></div>
            <span class="modal-head-title">Alterar Logo</span>
          </div>
          <v-card-text>
            <div v-show="loading" class="text-xs-center">
              <v-progress-circular
                indeterminate
                v-bind:color="color"
              ></v-progress-circular>
              <p class="mt-2">Fazendo upload do logo...</p>
            </div>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <label for="avatar">Escolha a imagem para o logotipo:</label>
                  <input
                    type="file"
                    id="partner_logo"
                    ref="partner_logo"
                    v-on:change="handleFileUpload()"
                    accept="image/*"
                  />
                  <p style="color: #808080">Recomendado: 500 x 500px</p>
                  <p style="color: #808080">Formatos aceitos: PNG, JPG, JPEG, GIF</p>
                </v-flex>
                <v-flex xs12 v-if="uploadProgress > 0 && uploadProgress < 100">
                  <v-progress-linear
                    :value="uploadProgress"
                    color="primary"
                    height="20"
                  >
                    <template v-slot:default="{ value }">
                      <strong>{{ Math.ceil(value) }}%</strong>
                    </template>
                  </v-progress-linear>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showChangeLogoForm"
              >Fechar</v-btn
            >
            <v-btn 
              color="primary" 
              @click="sendLogo" 
              :disabled="!partner_logo || loading"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "logoForm",
  data: () => ({
    newLogo: null,
    partner_logo: "",
    uploadProgress: 0,
  }),
  created() {},
  computed: {
    ...mapGetters({
      showLogoForm: "account/showLogoForm",
      loading: "account/loading",
      color: "account/color",
    }),
  },
  watch: {
    // Watcher removido para evitar conflitos com computed properties
  },
  methods: {
    showChangeLogoForm() {
      this.$store.dispatch("account/showLogoForm", false);
    },
    handleFileUpload() {
      this.partner_logo = this.$refs.partner_logo.files[0];
      this.uploadProgress = 0;
    },
    async sendLogo() {
      if (!this.partner_logo) {
        this.$store.dispatch("account/errorMessage", "Por favor, selecione um arquivo");
        return;
      }

      // Validar tipo de arquivo
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      if (!allowedTypes.includes(this.partner_logo.type)) {
        this.$store.dispatch("account/errorMessage", "Formato de arquivo não suportado. Use PNG, JPG, JPEG ou GIF");
        return;
      }

      // Validar tamanho (máximo 5MB)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (this.partner_logo.size > maxSize) {
        this.$store.dispatch("account/errorMessage", "Arquivo muito grande. Tamanho máximo: 5MB");
        return;
      }

      try {
        this.uploadProgress = 10;
        await this.$store.dispatch("account/sendLogo", this.partner_logo);
        this.uploadProgress = 100;
        
        // Aguardar um pouco para garantir que o backend processou
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Recarregar dados da conta para atualizar a logo
        await this.$store.dispatch("account/getAccount");
        
        // Forçar atualização da configuração do sistema ignorando cache
        await this.$store.dispatch("system/forceUpdateSystemConfiguration");
        
        // Forçar re-renderização de todos os componentes que usam logo
        this.$nextTick(() => {
          // Emitir evento para forçar atualização de logos
          this.$root.$emit('logo-updated');
        });
        
        // Limpar formulário
        this.partner_logo = "";
        this.$refs.partner_logo.value = "";
        this.uploadProgress = 0;
        
        // Fechar modal
        this.showChangeLogoForm();
        
        // Mostrar mensagem de sucesso
        this.$store.dispatch("account/successMessage", "Logo atualizado com sucesso!");
        
      } catch (error) {
        console.error('Erro ao enviar logo:', error);
        this.uploadProgress = 0;
        this.$store.dispatch("account/errorMessage", "Erro ao enviar logo. Tente novamente.");
      }
    },
  },
};
</script>
